module.exports = __webpack_public_path__ + "media/images/flags/1x1/lux-e89ca797c80d1a160d0e6fa7b3c4ca7b.svg";